module.exports = __webpack_public_path__ + "img/back-page.b5c0dc86.svg";